
  import React from 'react';
import { 
    useVendorAgreementLinesCols,
    useVendorAgreementServiceLinesCols
} from '../hooks/VendorCols';
import DashboardAthenaTable from './DashboardAthenaTable';
import CommentDialog from './CommentDialog';

export default function VendorAgreementLinesTable(props) {
    // Get agreement type code - check headers first, then agreementData
    // The agreementType in headers should be the code ('V', 'B', 'C', 'S', 'T')
    // If not available, map from agreementData AGMT_TYPE display value
    let agreementTypeCode = props.headers?.agreementType || '';
    
    // If not in headers, try to get from agreementData
    if (!agreementTypeCode && props.agreementData?.AGMT_TYPE) {
        const agreementTypeMap = {
            'Contract': 'C',
            'Blanket': 'B',
            'Standing': 'S',
            'Catalog/Quote': 'T',
            'Service': 'V'
        };
        agreementTypeCode = agreementTypeMap[props.agreementData.AGMT_TYPE] || '';
    }
    
    const vendorAgreementLinesCols = useVendorAgreementLinesCols();
    const vendorAgreementServiceLinesCols = useVendorAgreementServiceLinesCols();

    // Use service lines if agreement type is 'V' (Service), otherwise use regular lines
    const cols = agreementTypeCode === 'V' ? vendorAgreementServiceLinesCols : vendorAgreementLinesCols;
    const queryName = getQueryName(agreementTypeCode);

    const transformData = (data) => {
        return data.map((item) => {
        return {
            ...item,
            COMMENT_VIEW: item.COMMENT_INDEX ? (
                <CommentDialog
                  {...props}
                  erp="lawson"
                  text="view"
                  fileName={item.COMMENT_FILENAME}
                  index={item.COMMENT_INDEX}
                />
              ) : '',
            ITEM_LINK: (item.ITEM ? (
                <span className='editLink' onClick={() => {
                    const win = window.open(
                        `/item?itemGroup=${item.ITEM_GROUP}&item=${item.ITEM}`,
                        '_blank'
                    )
                    win.focus()
                }}>{item.ITEM_DESC}</span>
            ) : '')
            
        }
    })
  }
  return (
    <>
        <DashboardAthenaTable
            {...props}
            params={{ ...props.headers }}
            tableColumns={cols}
            reportParamName={queryName}
            reportName={queryName}
            tableTitle={''}
            transform={transformData}
            callback={()=>{}}
            downloadFileName={`${agreementTypeCode === 'V' ? 'Service_' : ''}Agreement_Lines_Download`}
        />
    </>
  );
}


const getQueryName = (type) => {
    if (type === 'V') {
    return 'po_vendor_agreement_service_lines';
    } else {
    return 'po_vendor_agreement_lines';
    }
}
